@if (!isFolder) {
  <div
    class="color-pill"
    [ngClass]="{ 'clickable': clickable }"
    fxLayout="row"
    fxLayoutAlign="center center"
    (click)="onClick()">
    <div
      [ngStyle]="{ 'background-color': colorCode }"
      class="left-end-cap">
      <img style="width: 0px; height: 40px" />
    </div>
    <div
      [ngStyle]="{ 'background-color': colorCode }"
      class="count"
      [ngClass]="textColorClass"
      fxLayout="row"
      fxLayoutAlign="center center">
      {{ count }}
    </div>
    <div
      [ngStyle]="{ 'background-color': colorCode }"
      class="right-end-cap">
      <img style="width: 0px; height: 40px" />
    </div>
  </div>
}
@if (isFolder) {
  <div
    class="color-pill"
    fxLayout="row"
    fxLayoutAlign="end"
    >
    <div
      class="folder-pill count"
      [ngClass]="textColorClass"
      fxLayout="row"
      fxLayoutAlign="center center">
      <div>{{ count }}</div>
    </div>
  </div>
}
